import { DateTime } from "luxon";
import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_CHOOSE_DATE_AND_TIME,
  TEXT_PICKUP_DATE_AND_TIME,
  TEXT_RETURN_DATE_AND_TIME,
} from "../../../utils/useConstants";
import {
  FunctionChangeFormatDateAgain,
  FunctionCloneSetValueToSesstion,
  FunctionCreateDay,
  FunctionCreateMonth,
  FunctionCreateYear,
  toISO,
} from "../../../utils/useFunction";
import {
  STYLE_BORDER_BUSKET_POPUP,
  STYLE_DATE_COMMON,
  STYLE_DATE_DISABLED,
  STYLE_DATE_NORMAL,
  STYLE_DATE_SELECTED,
  STYLE_FULLDATE,
  STYLE_HEAD_PICK_DATE_AND_TIME,
  STYLE_NAME_DATE,
} from "../../../utils/useStyle";
import { useWindowSize } from "../../../utils/useWindowSize";
import {
  BusketGenerateDate,
  BusketGenerateFutureDate,
  MAPPING_DATE,
  THIS_TIME_IN_N_OUT,
} from "../function/Busket.GenerateDate";
import BasketFindNextSlot from "./Basket.FindNextSlot";

export const time = [
  // "08:00 - 10:00",
  "10:00 - 12:00",
  "12:00 - 14:00",
  "14:00 - 16:00",
  "16:00 - 19:00",
  // "19:00 - 21:00",
];

export const checkTime = {
  "08:00 - 10:00": 10, // value of number : mean => what time is it at the moment
  "10:00 - 12:00": 12,
  "12:00 - 14:00": 14,
  "14:00 - 16:00": 16,
  "16:00 - 19:00": 19,
  "19:00 - 21:00": 21,
};

export const startTime = {
  "08:00 - 10:00": 8,
  "10:00 - 12:00": 10,
  "12:00 - 14:00": 12,
  "14:00 - 16:00": 14,
  "16:00 - 19:00": 16,
  "19:00 - 21:00": 19,
};

export const inverseTime = {
  10: "08:00 - 10:00",
  12: "10:00 - 12:00",
  14: "12:00 - 14:00",
  16: "14:00 - 16:00",
  19: "16:00 - 19:00",
  21: "19:00 - 21:00",
};

export const CONSTANT_CALENDAR = {
  "08:00 - 10:00": [
    "season_one_planned",
    "season_one_booked",
    "season_one_remaining",
  ],
  "10:00 - 12:00": [
    "season_two_planned",
    "season_two_booked",
    "season_two_remaining",
  ],
  "12:00 - 14:00": [
    "season_three_planned",
    "season_three_booked",
    "season_three_remaining",
  ],
  "14:00 - 16:00": [
    "season_four_planned",
    "season_four_booked",
    "season_four_remaining",
  ],
  "16:00 - 19:00": [
    "season_five_planned",
    "season_five_booked",
    "season_five_remaining",
  ],
  "19:00 - 21:00": [
    "season_six_planned",
    "season_six_booked",
    "season_six_remaining",
  ],
};

export const thisHourPushthirtyMinites = DateTime.now()
  .plus({ minutes: 30 })
  .setLocale("th")
  .setZone("UTC+7")
  .get("hour");

const BusketRenderSelectDateAndTime = ({
  value,
  setValue,
  nameDate,
  nameTime,
  calendars,
  title,
}) => {
  const isToday = (date) => {
    return (
      date.getDate() === FunctionCreateDay() &&
      date.getMonth() + 1 === FunctionCreateMonth() &&
      date.getFullYear() === FunctionCreateYear()
    );
  };
  const { language } = React.useContext(ContextLanguage);
  const datePlusOne =
    new Date(toISO(value?.pick_up_date?.date)).getTime() + 86400000;

  const isNotReturnToday =
    nameDate === "return_date" && nameTime === "return_time" && datePlusOne;

  const disabled =
    nameDate === "return_date" &&
    nameTime === "return_time" &&
    (!value?.pick_up_date?.date || !value?.pick_up_time);

  const DATE_FROM_GANERATE =
    nameDate === "return_date"
      ? BusketGenerateFutureDate(
          nameDate === "return_date",
          datePlusOne,
          calendars
        )
      : BusketGenerateDate(calendars);

  let moreThanOneDay = false;

  if (
    nameDate === "return_date" &&
    value?.pick_up_date?.date &&
    value?.pick_up_time
  ) {
    const pickUpDate = new Date(toISO(value?.pick_up_date?.date)).getTime();
    const returnDate = new Date(toISO(value?.return_date?.date)).getTime();
    if (returnDate - pickUpDate > 86400000) {
      moreThanOneDay = true;
    }
  }

  if (nameDate === "pick_up_date" && value?.pick_up_date?.date) {
    const pickUpDate = new Date(toISO(value?.pick_up_date?.date)).getTime();
    const toDay = DateTime.now().setZone("UTC+7").startOf("day").toMillis();

    if (pickUpDate - toDay >= 86400000) {
      moreThanOneDay = true;
    }
  }

  // console.log("DATE_FROM_GANERATE", DATE_FROM_GANERATE);

  return (
    <React.Fragment>
      <div
        className={`${STYLE_HEAD_PICK_DATE_AND_TIME(language)} ${
          language === "EN" ? "font-Poppins" : "font-NotoSansThai"
        }`}
      >
        {title}
      </div>
      <div
        className={`flex space-x-2 p-4 md:pt-0 md:pb-[14px] md:px-6 overflow-x-scroll  duration-0`}
      >
        {DATE_FROM_GANERATE?.map((o, i, self) => {
          const thisDisableDate =
            (disabled && nameDate !== "pick_up_date") || o?.disabled;

          // console.log("SELECTED ", {
          //   thisValue: value,
          //   thisRow: o,
          //   checkThisValue: value[nameDate]?.name === o.name,
          //   thisDay: FunctionCreateDay(),
          //   disabled,
          //   self,
          // });

          // if (o?.day === FunctionCreateDay() && FunctionCreateHour() > 19) {
          //   return <React.Fragment />;
          // }
          return (
            <div
              key={`key-of-date-${i}`}
              className={`${
                thisDisableDate
                  ? STYLE_DATE_DISABLED
                  : value[nameDate]?.name === o.name
                  ? STYLE_DATE_SELECTED
                  : STYLE_DATE_NORMAL
              }  ${STYLE_DATE_COMMON(language)} ${
                language === "TH" ? "  w-[125px]" : "  w-[105px]"
              } `}
              onClick={() => {
                if (!thisDisableDate) {
                  // alert(`${JSON.stringify(value[nameDate])}`);
                  if (nameDate === "pick_up_date") {
                    const findNextDate = BasketFindNextSlot({
                      selected: value[nameDate],
                      calendars,
                      thisDate: o,
                      self,
                    });
                    // console.log("findNextDate", findNextDate);
                    if (findNextDate) {
                      // console.log("IN 1");
                      if (value[nameDate]?.name === o.name) {
                        // console.log("1.1");
                        return;
                      } else {
                        // console.log("1.2");
                        FunctionCloneSetValueToSesstion("date_time", setValue, {
                          ...value,
                          [nameDate]: o,
                          return_date: findNextDate,
                          return_time: THIS_TIME_IN_N_OUT,
                          pick_up_time: THIS_TIME_IN_N_OUT,
                        });
                      }
                    } else {
                      // console.log("IN 2");
                      if (value[nameDate]?.name === o.name) {
                        // console.log("2.1");
                        return;
                      } else {
                        // console.log("2.2");
                        FunctionCloneSetValueToSesstion("date_time", setValue, {
                          ...value,
                          [nameDate]: o,
                          return_date: {
                            date: "",
                          },
                          return_time: THIS_TIME_IN_N_OUT,
                          pick_up_time: THIS_TIME_IN_N_OUT,
                        });
                      }
                    }
                  } else {
                    // console.log("IN 3");
                    if (value[nameDate]?.name === o.name) {
                      // console.log("3.1");
                      return;
                    } else {
                      // console.log("3.2");
                      FunctionCloneSetValueToSesstion("date_time", setValue, {
                        ...value,
                        [nameDate]: o,
                      });
                    }
                  }
                } else {
                  return;
                }
              }}
            >
              <div className={STYLE_NAME_DATE(language)}>
                {language === "TH" ? (
                  <React.Fragment>{MAPPING_DATE[o.name]}</React.Fragment>
                ) : (
                  <React.Fragment>{o.name}</React.Fragment>
                )}
              </div>
              <div className={STYLE_FULLDATE(language)}>
                {FunctionChangeFormatDateAgain(o?.date)}
              </div>
            </div>
          );
        })}
      </div>
      {/* <div
        className={`flex space-x-2 p-4 md:p-0 md:pb-3 md:px-6 py-2  overflow-x-scroll  duration-0`}
      >
        {time?.map((o, i) => {
          const past = time.findIndex((d) => {
            return d === value.pick_up_time;
          });

          const findSelfOfTime =
            calendars?.find((thisDay) => {
              if (nameDate === "pick_up_date") {
                return thisDay?.showDate === value?.pick_up_date?.date;
              }
              if (nameDate === "return_date") {
                return thisDay?.showDate === value?.return_date?.date;
              }
            }) || {};

          let remaining = 0;

          if (findSelfOfTime?.location) {
            const plan = findSelfOfTime[CONSTANT_CALENDAR[o][0]];
            const booked = findSelfOfTime[CONSTANT_CALENDAR[o][1]];
            remaining = plan - booked;
          }

          const thisDisableTime =
            remaining <= 0 // ยังมี slot เหลืออยู่ไหม
              ? true
              : moreThanOneDay // เลือกมากกว่า 1 วันหรือเปล่า
              ? false
              : (past > i && nameTime !== "pick_up_time") || // เงือนไขคือ เป็น รับ หรือ เป็น ส่ง
                disabled || // ปิดมาจากหลังบ้านหรือเปล่า
                (checkTime[o] <= thisHourPushthirtyMinites && // เวลามีค่ามากว่าเวลาปัจจุบันหรือเปล่า + 30 นาที
                  isToday(new Date(toISO(value[nameDate]?.date)))) ||
                (value[nameDate]?.date === "" && FunctionCreateHour() === 23);

          // console.log("CHECK : ", {
          //   past,
          //   i,
          //   remaining,
          //   thisDisableTime,
          //   thisHourPushthirtyMinites,
          //   self: checkTime[o],
          // });

          if (thisDisableTime) {
            return <React.Fragment />;
          } else {
            return (
              <div
                key={`key-of-time-${i}`}
                className={`${
                  thisDisableTime
                    ? STYLE_DATE_DISABLED
                    : value[nameTime] === o
                    ? STYLE_DATE_SELECTED
                    : STYLE_DATE_NORMAL
                }  ${STYLE_DATE_COMMON} ${
                  language === "TH" ? "  w-[125px]" : "  w-[105px]"
                } h-full `}
                onClick={() => {
                  if (!thisDisableTime) {
                    if (nameTime === "pick_up_time") {
                      const findNearestTime = FunctionFindNearestToDate(
                        calendars,
                        value.pick_up_date?.date,
                        o
                      );

                      // console.log("CKECK CLICK : ", {
                      //   findNearestTime,
                      //   value,
                      //   o,
                      // });

                      if (findNearestTime) {
                        FunctionCloneSetValueToSesstion("date_time", setValue, {
                          ...value,
                          [nameTime]: value[nameTime] === o ? "" : o,
                          return_time: findNearestTime?.return_time,
                          return_date: findNearestTime?.return_date,
                        });
                      } else {
                        FunctionCloneSetValueToSesstion("date_time", setValue, {
                          ...value,
                          [nameTime]: value[nameTime] === o ? "" : o,
                          return_time: "",
                        });
                      }
                    } else {
                      FunctionCloneSetValueToSesstion("date_time", setValue, {
                        ...value,
                        [nameTime]: value[nameTime] === o ? "" : o,
                      });
                    }
                  } else {
                    return;
                  }
                }}
              >
                {o}
              </div>
            );
          }
        })}
      </div> */}

      {nameDate === "pick_up_date" && (
        <div className={STYLE_BORDER_BUSKET_POPUP}></div>
      )}
      {nameDate === "return_date" && (
        <div className={STYLE_BORDER_BUSKET_POPUP}></div>
      )}
    </React.Fragment>
  );
};

const BusketModalDateTime = ({ value, setValue, calendars, isMobile }) => {
  const size = useWindowSize();

  const { language } = React.useContext(ContextLanguage);

  // React.useEffect(() => {
  //   if (value?.isDateTimeOpen) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "unset";
  //   }
  // }, [value]);

  return (
    <div className="bg-white rounded-[16px]">
      <div
        style={{
          width: isMobile
            ? size.width * 1
            : size.width * 0.5 > 680
            ? 680
            : size.width * 0.5,
          // height: isMobile ? size.height * 0.9 : size.height * 0.74,
          height: isMobile ? "unset" : language === "TH" ? 495 : 480,
        }}
        className={`  ${
          language === "TH" ? " font-NotoSansThai " : " font-Poppins "
        } overflow-y-scroll `}
      >
        <div
          className={`${
            language === "TH"
              ? " text-base-th md:text-lg-th "
              : " text-base md:text-lg"
          } text-laudry-gray-200 font-semibold border-b border-[#D9DBE9] p-4 md:p-6 `}
        >
          <div
            className={`text-left  ${
              language === "EN" ? "font-Poppins" : "font-NotoSansThai"
            }`}
          >
            {" "}
            {TEXT_CHOOSE_DATE_AND_TIME[language]}
          </div>
        </div>
        <BusketRenderSelectDateAndTime
          titleDate={`Pick-Up Date`}
          titleTime={`Pick-Up Time`}
          title={TEXT_PICKUP_DATE_AND_TIME[language]}
          value={value}
          setValue={setValue}
          nameDate={`pick_up_date`}
          nameTime={`pick_up_time`}
          calendars={calendars}
        />
        <BusketRenderSelectDateAndTime
          titleDate={`Return Date`}
          titleTime={`Returm Time`}
          title={TEXT_RETURN_DATE_AND_TIME[language]}
          value={value}
          setValue={setValue}
          nameDate={`return_date`}
          nameTime={`return_time`}
          calendars={calendars}
        />
        {isMobile && <div className=" pb-[106px]"></div>}
      </div>
    </div>
  );
};

export default BusketModalDateTime;
